import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="80vh"
      textAlign="center"
      px={2}
    >
      <Typography variant="h4" gutterBottom>
        Accès refusé
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 520 }}>
        Vous n’avez pas accès à cette fonctionnalité avec votre configuration actuelle.
      </Typography>
      <Box mt={3} display="flex" gap={2}>
        <Button variant="contained" onClick={() => navigate("/dashboard")}>
          Retour au dashboard
        </Button>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Revenir en arrière
        </Button>
      </Box>
    </Box>
  );
};

export default AccessDenied;

